import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

import LoginComponent from './views/Login.vue';
import AboutComponent from './views/About.vue';
import JbrowseComponent from './views/Jbrowse.vue';
import SearchComponent from './views/Search.vue';
import BlastComponent from './views/Blast.vue';
import ChangePasswordComponent from './views/ChangePassword.vue';
import SpeciesSet from './views/SpeciesSet.vue';
import RemoveSets from './views/RemoveSets.vue';
import AssignCategories from './views/AssignCategories.vue';
import Content from './views/Content.vue';
import ForgotPassword from './views/ForgotPassword.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/home',
      name: 'home2',
      component: Home,
    },
    {
      path: '/user/login',
      name: 'login',
      component: LoginComponent,
    },
    {
      path: '/user/speciesSet',
      name: 'speciesSet',
      component: SpeciesSet,
    },
    {
      path: '/user/removeSets',
      name: 'removeSets',
      component: RemoveSets,
    },
    {
      path: '/about',
      name: 'about',
      component: AboutComponent,
    },
    {
      path: '/jbrowse',
      name: 'jbrowse',
      component: JbrowseComponent,
    },
    {
      path: '/search',
      name: 'search',
      component: SearchComponent,
    },
    {
      path: '/blast',
      name: 'blast',
      component: BlastComponent,
    },
    {
      path: '/user/changePassword',
      name: 'changePassword',
      component: ChangePasswordComponent,
    },
    {
      path: '/admin/assignCategories',
      name: 'assignCategories',
      component: AssignCategories,
    },
    {
      path: '/content',
      name: 'content',
      component: Content,
    },
    {
      path: '/user/forgotPassword',
      name: 'forgotPassword',
      component: ForgotPassword,
    },
  ],
});
